import axios from "axios";
import { showAlert, handleRequestError } from "../../utils/alert";

export default () => ({
  email: "",
  password: "",
  isLoading: false,

  // Alpine lifecycle hook: Runs automatically when the component is initialized
  init() {
    this.checkExistingSession();
    this.checkVerificationParams();
  },

  checkExistingSession() {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      window.location.href = "/client/dashboard";
    }
  },

  // Nova função para processar as mensagens de ativação
  checkVerificationParams() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("verified")) {
      showAlert(
        "E-mail verificado com sucesso! Sua conta está ativa, faça o login.",
        "success",
      );
      this.cleanUrlParams();
    } else if (urlParams.has("error")) {
      const errorType = urlParams.get("error");
      if (errorType === "invalid_signature") {
        showAlert("O link de ativação é inválido ou já expirou.", "warning");
      } else {
        showAlert(
          "Ocorreu um erro ao ativar a conta. Entre em contato com o suporte.",
          "error",
        );
      }
      this.cleanUrlParams();
    }
  },

  // Remove os parâmetros da URL visualmente mantendo o histórico limpo
  cleanUrlParams() {
    window.history.replaceState(null, null, window.location.pathname);
  },

  async submitLogin() {
    this.isLoading = true;

    if (!this.email) {
      showAlert("E-mail é obrigatório", "warning");
      this.isLoading = false;
      return;
    }

    if (!this.password) {
      showAlert("Senha é obrigatória", "warning");
      this.isLoading = false;
      return;
    }

    const turnstileResponseInput = document.querySelector(
      '[name="cf-turnstile-response"]',
    );
    const turnstileToken = turnstileResponseInput
      ? turnstileResponseInput.value
      : null;

    if (!turnstileToken) {
      showAlert("Por favor, resolva o desafio de segurança.", "warning");
      this.isLoading = false;
      return;
    }

    try {
      // Adicionamos explicitamente o header Accept: application/json
      const response = await axios.post(
        "/api/client/auth/login",
        {
          email: this.email,
          password: this.password,
          "cf-turnstile-response": turnstileToken,
        },
        {
          headers: {
            Accept: "application/json",
          },
        },
      );

      localStorage.setItem("jwt_token", response.data.access_token);
      await showAlert("Login realizado com sucesso!", "success");
      window.location.href = "/client/dashboard";
    } catch (error) {
      // Agora o bloco catch vai capturar corretamente o JSON de erro 422 ou 403
      handleRequestError(error, "E-mail ou senha inválidos.");

      // Limpa e reseta o captcha para nova tentativa em caso de falha
      if (window.turnstile) {
        window.turnstile.reset();
      }
    } finally {
      this.isLoading = false;
    }
  },
});
